(function () {
  'use strict';

  angular
    .module('back.forward.navi')
    .controller('backForwardNaviCtrl', backForwardNaviCtrl);

  backForwardNaviCtrl.$inject = ['$window', '$rootScope'];

  function backForwardNaviCtrl($window, $rootScope) {
    var vm = this;

    vm.goBack = function () {
      $window.history.back();
    };

    vm.goForward = function () {
      $window.history.forward();
    };
  }
})();
